// extracted by mini-css-extract-plugin
export default {"content":"style_content__HGWE2","intro":"style_intro__Dvk7i","brand_grid":"style_brand_grid__SMVQB"};